import { PostHogAnalyticsService } from '../posthog-analytics-service';
import { ClientPostHogImpl } from './implementation';

/**
 * Create a client-side PostHog analytics service.
 */
export function createPostHogAnalyticsService() {
  const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  const host = process.env.NEXT_PUBLIC_POSTHOG_HOST;
  const url = process.env.NEXT_PUBLIC_POSTHOG_INGESTION_URL;

  // When PostHog is not configured, return a no-op service
  if (!key || !host) {
    console.warn('PostHog not configured. Analytics will be disabled.');
    return new PostHogAnalyticsService(
      new NoOpPostHogImpl(),
      key || 'no-key',
      host || 'no-host',
    );
  }

  const client = new ClientPostHogImpl(key, host, url);
  return new PostHogAnalyticsService(client, key, host);
}

/**
 * No-op implementation for when PostHog is not configured
 */
class NoOpPostHogImpl {
  async initialize() {
    // No-op
  }

  async identify(_userId: string, _traits?: Record<string, string>) {
    // No-op
  }

  async group(
    _groupType: string,
    _groupKey: string,
    _groupProperties?: Record<string, string>,
  ) {
    // No-op
  }

  async trackPageView(_url: string) {
    // No-op
  }

  async trackEvent(
    _eventName: string,
    _eventProperties?: Record<string, string | string[]>,
  ) {
    // No-op
  }

  async registerProperties(_properties: Record<string, string>) {
    // No-op
  }

  async unregisterProperty(_key: string) {
    // No-op
  }

  log(..._args: unknown[]) {
    // No-op
  }
}
